var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanremains2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 0H31.8C33.2057 0 34.5537 0.554509 35.5477 1.54154C36.5416 2.52858 37.1 3.86728 37.1 5.26316V10.5263H47.7C49.1056 10.5263 50.4537 11.0808 51.4477 12.0679C52.4416 13.0549 53 14.3936 53 15.7895V44.7368C53 46.1327 52.4416 47.4714 51.4477 48.4585C50.4537 49.4455 49.1056 50 47.7 50H5.3C3.89435 50 2.54628 49.4455 1.55233 48.4585C0.558391 47.4714 0 46.1327 0 44.7368V15.7895C0 12.8684 2.3585 10.5263 5.3 10.5263H15.9V5.26316C15.9 2.34211 18.2585 0 21.2 0ZM31.8 10.5263V5.26316H21.2V10.5263H31.8Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanremains2);
export default __webpack_public_path__ + "static/media/humanremains2.5e1631df90200a4d3a2baed42f573c4e.svg";
export { ForwardRef as ReactComponent };